import React from 'react';
import { ProductsGrid } from '@wix/package-picker-components';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import {
  AdvancedPlansFeature,
  AdvancedPlansProductData,
  FeaturesGroupSection,
} from '../../../types';
import { RootStore, withInjectedRootStore } from 'providers';
import { useProductsGridRefContext } from 'providers/ProductsGridContextRefProvider/ProductsGridContextRefProvider';
import { GridHeader } from './GridHeader';
import { CollapsibleGroup } from './CollapsibleGroup';
import { Seperator } from '../../../pages/PlansPage/AdvancedPlans/Seperator/Seperator';
import s from './PlansGrid.scss';

interface PlansGridProps extends InjectedExperimentsProps {
  rootStore: RootStore;
  products: AdvancedPlansProductData[];
  onClickSelect(productData: AdvancedPlansProductData): void;
  features: AdvancedPlansFeature[];
  groups: FeaturesGroupSection[];
}

const PlansGridComp: React.FC<PlansGridProps> = ({
  rootStore,
  products,
  onClickSelect,
  groups,
}) => {
  const gridRef = React.useRef<HTMLDivElement>(null);
  const gridHeaderRef = React.useRef<HTMLDivElement>(null);
  const { isJapanesePackagePicker } = rootStore.appStore;
  const { setRef } = useProductsGridRefContext();
  React.useEffect(() => {
    setRef && setRef(gridRef);
  }, []);

  return (
    <ProductsGrid
      className={s.gridContainer}
      productsCount={products.length}
      innerRef={gridRef}
    >
      <GridHeader
        products={products}
        onClickSelect={onClickSelect}
        innerRef={gridHeaderRef}
      />

      {groups?.map((group) => (
        <CollapsibleGroup
          group={group}
          key={group.translationKey}
          products={products}
          isJapanesePackagePicker={isJapanesePackagePicker}
        />
      ))}
      <Seperator />
    </ProductsGrid>
  );
};

export const PlansGrid = withExperiments(withInjectedRootStore(PlansGridComp));
